import { useModal } from "@/app/hooks/ui_hooks/useModal";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { Dialog, Transition } from "@headlessui/react";
import clsx from "clsx";
import { Fragment, useEffect } from "react";
import BackdropComponent from "../../Backdrop";
import { IModalInformationProps } from "../modals_interface";

const ModalInformation: React.FC<React.PropsWithChildren<IModalInformationProps>> = ({
  modalId,
  title,
  titleIcon,
  onVisibleCallback,
  ...props
}) => {
  const { setInvisible } = useModalActions(modalId);
  const isModalVisible = useModal(modalId);

  useEffect(() => {
    if (isModalVisible) {
      if (onVisibleCallback) {
        onVisibleCallback();
      }
    }
  }, [isModalVisible]);
  return (
    <Transition appear show={isModalVisible} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-40"
        onClose={() => {
          if (props?.persistent) return;
          setInvisible();
        }}
      >
        <BackdropComponent blur={props?.backdropBlur} />
        <div className="fixed inset-0 w-screen overflow-y-auto">
          <div className="flex justify-center items-end sm:items-center p-4 sm:p-0 min-h-full text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={clsx(
                  "relative border-gray-200 bg-white px-4 pt-5 pb-4 border rounded-lg text-left transform transition-all translate-x-20",
                  props?.dialogClassName ? props?.dialogClassName : "sm:my-8 sm:w-full sm:max-w-lg sm:p-6",
                  props?.contentOverflow ? "overflow-visible" : "overflow-hidden",
                )}
              >
                <Dialog.Title
                  as="h3"
                  className="flex justify-between items-center font-medium text-gray-900 text-sm leading-6"
                >
                  {titleIcon}
                  <span className="ml-2">{title ?? "Add Title"}</span>
                  {/* <span>
                    <XMarkIcon className="w-4 h-4 cursor-pointer" onClick={() => setInvisible()} />
                  </span> */}
                </Dialog.Title>
                {props?.children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalInformation;
